import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    fontSize: 12,
    lineHeight: 1.6,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 40,
  },
  leftColumn: {
    flex: 1,
  },
  rightColumn: {
    flex: 1,
    alignItems: 'flex-end',
    marginTop: 25, // ← DÉCALAGE VERS LE BAS
  },
  candidateName: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  candidateDetail: {
    fontSize: 11,
    marginBottom: 2,
    color: '#333333',
  },
  companyText: {
    fontSize: 11,
    marginBottom: 2,
    color: '#333333',
    textAlign: 'right',
  },
  date: {
    marginBottom: 30,
    textAlign: 'right',
  },
  subject: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  salutation: {
    marginBottom: 15,
  },
  body: {
    marginBottom: 15,
    textAlign: 'justify',
  },
  signature: {
    marginTop: 40,
  },
  signatureName: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 30,
  }
});

const CoverLetterDocument = ({ formData = {}, coverLetterData = {}, language }) => {
  // Utilise les données du formulaire, sinon celles du CV
  const candidateName = coverLetterData.candidateName || formData.name || '[Prénom & Nom du candidat]';
  const candidateAddress = coverLetterData.candidateAddress || formData.address || '[Adresse du candidat]';
  const candidatePhone = coverLetterData.candidatePhone || formData.phone || '[Numéro Téléphone]';
  const candidateEmail = coverLetterData.candidateEmail || formData.email || '[Adresse e-mail]';

  const safeCoverLetterData = {
    companyName: coverLetterData.companyName || '[Nom de l\'entreprise]',
    hiringManager: coverLetterData.hiringManager || '[Nom du recruteur ou du Service]',
    positionTitle: coverLetterData.positionTitle || '[Intitulé du poste]',
    letterBody: coverLetterData.letterBody || '[Contenu de la lettre de motivation]',
  };

  const currentDate = new Date().toLocaleDateString(language === 'fr' ? 'fr-FR' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* En-tête avec 2 colonnes */}
        <View style={styles.header}>
          {/* Colonne GAUCHE - Informations candidat */}
          <View style={styles.leftColumn}>
            <Text style={styles.candidateName}>{candidateName}</Text>
            <Text style={styles.candidateDetail}>{candidateAddress}</Text>
            <Text style={styles.candidateDetail}>{candidatePhone}</Text>
            <Text style={styles.candidateDetail}>{candidateEmail}</Text>
          </View>

          {/* Colonne DROITE - Informations entreprise (DÉCALÉE VERS LE BAS) */}
          <View style={styles.rightColumn}>
            <Text style={styles.companyText}>
              {language === 'fr' ? 'À l\'attention de' : 'To the attention of'}
            </Text>
            <Text style={styles.companyText}>{safeCoverLetterData.hiringManager}</Text>
            <Text style={styles.companyText}>{safeCoverLetterData.companyName}</Text>
          </View>
        </View>

        {/* Date à droite */}
        <View style={styles.date}>
          <Text style={styles.companyText}>
            {language === 'fr' ? `Le ${currentDate}` : `${currentDate}`}
          </Text>
        </View>

        {/* Objet */}
        <Text style={styles.subject}>
          {language === 'fr' 
            ? `Objet : Candidature pour le poste de ${safeCoverLetterData.positionTitle}`
            : `Subject: Application for ${safeCoverLetterData.positionTitle} position`}
        </Text>

        {/* Salutation */}
        <Text style={styles.salutation}>
          {language === 'fr' ? 'Madame, Monsieur,' : 'Dear Hiring Manager,'}
        </Text>

        {/* Corps de la lettre */}
        <Text style={styles.body}>
          {safeCoverLetterData.letterBody}
        </Text>

        {/* Signature */}
        <View style={styles.signature}>
          <Text style={styles.signatureName}>{candidateName}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default CoverLetterDocument;